import { createRoutine } from "../../redux/utils/routine.utils";
export var getQuote = createRoutine("QUOTE_GET");
export var createQuote = createRoutine("QUOTE_CREATE");
